import * as React from 'react';
import { Card } from '@codeparva/ui-components-library';
import { errorMessageHeading, errorImageUrl, errorMessagePara } from './config';
import { Link } from 'gatsby';

export const ErrorBoundaryForUnitCard = () => {
  return (
    <Card className="errorCard">
      <Card.Header className="errorCardHeader">
        <div className="errorCardHeader">
          <h3 className="has-text-primary header is-size-4 has-text-weight-bold">
            {errorMessageHeading}
          </h3>
        </div>
      </Card.Header>
      <Card.Content className="errorCardBody has-text-weight-bold">
        <div className="errorImageDiv">
          <img
            src={errorImageUrl}
            alt="A Simple Error Message"
            placeholder="blurred"
            loading="lazy"
          />
        </div>
      </Card.Content>
      <Card.Footer className="errorCardFooter is-size-5">
        <p className="has-text-black is-size-5">
          <Link
            to="/view-rates"
            className="has-text-primary has-text-weight-bold"
          >
            Click Here
          </Link>{' '}
          {errorMessagePara}
        </p>
      </Card.Footer>
    </Card>
  );
};

export default ErrorBoundaryForUnitCard;
